<template>
  <div>
    <div
      v-for="block in jsonData"
      :key="block.id">
      <component
        :is="getComponentByType(block.type)"
        class="container catalog-modules"
        :module-data="block"
        :products-data="productsMapping[block.id] || []"
        :is-loading="isLoadingProducts" />
    </div>
  </div>
</template>

<script>
import BannerModule from 'Root/pages/game/components/BannerModule.vue';
import OffersModule from 'Root/pages/game/components/OffersModule.vue';
import BaseCardList from 'Components/ui/BaseCardList/BaseCardList.vue';
import NeedHelp from 'Root/pages/game/components/NeedHelp.vue';
import CatalogModel from 'Models/CatalogModel';
import AppModel from 'Models/AppModel';
import axios from 'axios';
import { mapState } from 'vuex';

const { API_URI } = AppModel;

export default {
  name: 'CatalogModules',

  components: {
    BaseCardList,
    BannerModule,
    OffersModule,
    NeedHelp,
  },

  props: {
    jsonData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isLoadingProducts: true,
      localProducts: {},
    };
  },

  computed: {
    ...mapState(['activeGame']),

    productsMapping() {
      const mapping = {};
      if (!this.isLoadingProducts) {
        this.jsonData.forEach((block) => {
          const products = [];

          block.offers.forEach((offerId) => {
            const foundProduct = this.localProducts.find((product) => product.id === offerId);

            if (foundProduct) {
              products.push(foundProduct);
            }
          });

          mapping[block.id] = products;
        });
      }

      return mapping;
    },
  },

  watch: {
    'activeGame.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.isLoadingProducts = true;
          this.initializeProductData();
        }
      },
    },
  },

  created() {
    this.initializeProductData();
  },

  methods: {
    async initializeProductData() {
      const gameId = this.activeGame.id;

      if (this.$store.state.catalogProducts[gameId] && this.$store.state.catalogProducts[gameId].length > 0) {
        this.localProducts = this.$store.state.catalogProducts[gameId];
        this.isLoadingProducts = false;
      } else {
        await this.fetchProductsByGameId(gameId);
      }
    },

    fetchProductsByGameId(gameId) {
      return axios.post(`${API_URI}/catalog/products`, { game_ids: [gameId] })
        .then((response) => {
          this.localProducts = response.data.result;
          this.isLoadingProducts = false;
        });
    },

    getComponentByType(type) {
      switch (type) {
        case CatalogModel.CATALOG_BLOCK_TYPES.OFFERS:
          return OffersModule;
        case CatalogModel.CATALOG_BLOCK_TYPES.BANNER:
          return BannerModule;
        case CatalogModel.CATALOG_BLOCK_TYPES.CUSTOM_ORDER_BANNER:
          return NeedHelp;
        case CatalogModel.CATALOG_BLOCK_TYPES.CATALOG:
          return OffersModule;
        default:
          return null;
      }
    },
  },
};
</script>
